import React, { useEffect } from 'react'

import { PageHeader } from 'mailup-web-components'

import { useIntl } from 'react-intl'
import { useHistory } from 'react-router-dom'
import { useConditions } from 'Hooks'
import { notifyParent } from 'Helpers/notifyParent'
import useRedirectorUrl from 'Hooks/useRedirectorUrl'

const Header = () => {
  const intl = useIntl()
  const history = useHistory()
  const [redirectUrl] = useRedirectorUrl()

  const [hasSmtpPlus] = useConditions(
    'c:SmtpPlusOrFastEmailUsersPresent AND uo:SMTP+ AND co:SMTPV2ENABLED'
  )

  useEffect(() => {
    notifyParent('selectMenuItemReact', [
      'EmailSendStatusCampaign',
      redirectUrl
    ])
  }, [redirectUrl])

  const breadcrumbsItems = [
    {
      label: intl.formatMessage({ id: 'Load.NavMenu.Messages' }),
      'data-mu-test': 'breadcrumb-item__messages',
      className: 'test-breadcrumb-item__messages'
    },
    {
      label: intl.formatMessage({ id: 'Load.NavMenu.Email' }),
      'data-mu-test': 'breadcrumb-item__email',
      className: 'test-breadcrumb-item__email'
    },
    {
      label: intl.formatMessage({ id: 'Load.NavMenu.SendStatus' }),
      'data-mu-test': 'breadcrumb-item__send-status',
      className: 'test-breadcrumb-item__send-status'
    },
    {
      label: intl.formatMessage({ id: 'Load.NavMenu.SendStatusCampaign' }),
      'data-mu-test': 'breadcrumb-item__send-status__campaigns',
      className: 'test-breadcrumb-item__send-status__campaigns'
    }
  ]

  /* eslint-disable prettier/prettier */
  const menuItems = [
    {
      label: intl.formatMessage({ id: 'Load.NavMenu.SendStatusCampaign' }),
      'data-mu-test': 'topmenu-item__send-status__campaigns',
      className: 'test-topmenu-item__send-status__campaigns',
      isActive: true,
      onClick: () => null
    },
    ...(hasSmtpPlus
      ? [
          {
            label: intl.formatMessage({
              id: 'Load.NavMenu.SendStatusSmtpPlus'
            }),
            onClick: () => {
              history.push('/messages/email/sendstatus/smtpplus')
            },
            'data-mu-test': 'topmenu-item__send-status__smtpplus',
            className: 'test-topmenu-item__send-status__campaigns'
          }
        ]
      : []),
    {
      label: intl.formatMessage({ id: 'Load.NavMenu.ScheduledMailing' }),
      'data-mu-test': 'topmenu-item__send-status__scheduled',
      className: 'test-topmenu-item__send-status__campaigns',
      onClick: () => {
        history.push('/messages/email/sendstatus/scheduled')
      }
    }
  ]
  /* eslint-enable prettier/prettier */

  return (
    <PageHeader
      breadcrumbsItems={breadcrumbsItems}
      menuItems={menuItems}
      title={intl.formatMessage({ id: 'Load.NavMenu.SendStatusCampaign' })}
    />
  )
}

export default Header
